import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData } from '../../../js/server'
import { fnNotAdmin } from '../../../js/util'
import queryString from "query-string";
import SubMenu from '../../../comp/comm/SubMenu'
import List from '../../comm/List'
import Paging from '../../comm/Paging'
import { useHistory } from "react-router"
import SubBanner from '../../../comp/comm/SubBanner'

function MemberList({ match, location, history }) {
    const dispatch = useDispatch()
    const usehistory = useHistory()
    const query = queryString.parse(location.search);
    const [posts, setPosts] = useState({ items: [] });
    const [currentPage, setCurrentPage] = useState(1);
    // eslint-disable-next-line
    const [postsPerPage, setPostsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [userToken, setUserToken] = useState(null);
    const keyword = query.keyword
    const page = query.page

    async function fetchData(page = 1) {
        //Hash에 남길 State 저장
        setCurrentPage(Number(page))

        const jsonData = {
            "servicename": "ShopList",
            "userToken": userToken,
            "keyword": document.getElementById('inputKeyword').value,
            "currentPage": page,
            "maxListCount": postsPerPage
        }

        dispatch({ type: 'loadingChange', payload: true })
        reqData(jsonData).then((res) => {
            if (res.data.result === 'OK') {
                setTotalCount(res.data.totalCnt)
                setPosts(res.data.jsonData)
            } else {
                alert(res.data.msg)
            }
        }).catch((err) => {
            console.error(err)
        }).finally(() => {
            dispatch({ type: 'loadingChange', payload: false })
        })
    }

    const fnSearchClick = () => {
        if (document.getElementById('inputKeyword').value.length > 1) {
            fetchData(1)
        } else {
            alert('검색어는 2자 이상 필요합니다.')
        }
    }

    const setPage = (page) => {
        fetchData(page)
    }

    const newClick = () => {
        const keyword = document.getElementById('inputKeyword').value
        //검색 상태 Hash 저장
        window.document.location.hash = "#" + currentPage + "^" + encodeURI(keyword)
        usehistory.push(`/Admin/MemberNew`)
    }

    const listClick = (key) => {
        const keyword = document.getElementById('inputKeyword').value
        //검색 상태 Hash 저장
        window.document.location.hash = "#" + currentPage + "^" + encodeURI(keyword)
        usehistory.push(`/Admin/MemberView?comcode=${key}&page=${currentPage}&keyword=${encodeURI(keyword)}`)
    }

    useEffect(() => {
        dispatch({ type: 'pageChange', payload: { 'sub01': '관리자메뉴', 'sub02': '회원관리' } })
        dispatch({ type: 'loadingChange', payload: true })

        setTimeout(() => {
            //로그인 체크
            const userinfo = JSON.parse(localStorage.getItem('userinfo'))
            if (userinfo) {
                const userToken = userinfo.userToken
                setUserToken(userToken)

                //로그인 체크 후 Usertype 검사
                LoginToken(userToken).then((res) => {
                    if (res.data.result === 'OK') {
                        if (res.data.jsonData.usertype === '0') {
                            let defaultPage = 1

                            //검색 상태 Hash 불러오기
                            if (keyword || page) {
                                defaultPage = page
                                document.getElementById('inputKeyword').value = keyword
                            }
                            else if (window.document.location.hash) {
                                let strHash = window.document.location.hash
                                let arrCur = null

                                strHash = strHash.replace('#', '')
                                arrCur = strHash.split('^')
                                if (arrCur.length === 2) {
                                    defaultPage = (arrCur[0]) ? arrCur[0] : 1
                                    document.getElementById('inputKeyword').value = arrCur[1]
                                }
                            }

                            fetchData(defaultPage);
                        } else {
                            fnNotAdmin()
                        }
                    }
                }).catch((err) => {
                    console.error(err)
                    localStorage.removeItem('userinfo')

                    fnNotAdmin()
                }).finally(() => {
                    //dispatch({ type: 'loadingChange', payload: false })
                })
            } else {
                fnNotAdmin()
            }
        }, 500)
    },
        // eslint-disable-next-line
        []);

    return (
        <>
            <SubBanner id="admin" />

            <section className="admin section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-12">
                                    <h2>회원관리</h2>
                                    <span>업체등록후 홈페이지 가입이 가능합니다.</span>
                                </div>
                            </div>

                            <div className="row search-bar">
                                <div className="col-12">
                                    <div className="input-group mb-3 mt-3">
                                        <input type="text"
                                            id="inputKeyword"
                                            className="form-control"
                                            placeholder="업체명, 대표자명, 사업자등록번호"
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    fnSearchClick()
                                                }
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-custom-search"
                                                type="button"
                                                onClick={() => {
                                                    fnSearchClick()
                                                }} >
                                                <i className="icofont-search-2" />
                                            </button>
                                            <button className="btn btn-custom-init"
                                                type="button"
                                                onClick={() => {
                                                    document.getElementById('inputKeyword').value = ''

                                                    fetchData(1)
                                                }} >
                                                <i className="icofont-eraser" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row pb-10">
                                <div className="col-12">
                                    <button
                                        className="btn btn-light btn-custom-sm"
                                        type="button"
                                        onClick={newClick}><i className="icofont-edit-alt"></i>&nbsp;신규</button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="table-responsive datatable-list">
                                    <List posts={posts} id="MemberList" listClick={listClick} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <Paging page={currentPage} count={totalCount} setPage={setPage} />
                                </div>
                            </div>
                        </div>

                        <SubMenu id="admin" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default MemberList